import { ColumnDefinitionType } from "./Table";
import React, { useEffect, useState } from "react";
import Input from "../customhtmlcomponents/Input";
import TableOptionsGaverBidrag from "../gaverbidrag/TableOptionsGaverBidrag";
import TableOptionsEiendomType from "../eiendom/eiendomtableoptions/TableOptionsEiendomType";
import TableOptionsEiendomLeietaker from "../eiendom/eiendomtableoptions/TableOptionsEiendomLeietaker";
import TableOptionsEiendomDriftsform from "../eiendom/eiendomtableoptions/TableOptionsEiendomDriftsform";
import { TableRowsProps } from "./TableRows";

const labelStyle = { labelOn: true, defaultLabelStyle: false };
const labelClassName = "text-xl text-black flex text-right"
const VerticalRows = <T, K extends keyof T>({
  data,
  columns,
  removeRow,
  handleChange,
  addRow,
  isAdmin,
  showRowActions,
  entityName
}: TableRowsProps<T, K>): JSX.Element => {
  const [items, setItems] = useState(data);
  useEffect(() => {
    setItems(data);
  }, [handleChange]);

  const keys = items?.flatMap(
    (t) =>
      Object.keys(t)
        .filter((k) => k === "id")
        //@ts-ignore
        .map((key) => t[key]) ?? columns.map((c) => c.key === "id")
  ) as number[];
  // @ts-ignore

const tdClassName = "text-center text-xl font-thin block cursor-pointer border-sk-tertiary-blue";

  const getColumnCell = (item: T, index: number, column: ColumnDefinitionType<T, K>, cIndex: number, isUserEditingAdminColumn: boolean) => {
    const uniqueKey = `${index}-${cIndex}`
    if (column.key === "type") {
        return (
          <td key={`${uniqueKey}`} className={tdClassName}>
            <label className={labelClassName} htmlFor={`eiendomType-${uniqueKey}`}>
                {column.header}
            </label>
            <TableOptionsEiendomType
              id={`eiendomType-${uniqueKey}`}
              handleChange={handleChange}
              index={item}
              disabled={isUserEditingAdminColumn}
            />
          </td>
        );
      } else if (column.key === "leietaker") {
        return (
          <td key={`${uniqueKey}`} className={tdClassName}>
            <label className={labelClassName} htmlFor={`eiendomLeieTaker-${uniqueKey}`}>
                {column.header}
            </label>
            <TableOptionsEiendomLeietaker
              id={`eiendomLeieTaker-${uniqueKey}`}
              handleChange={handleChange}
              index={item}
              disabled={isUserEditingAdminColumn}
            />
          </td>
        );
      } else if (column.key === "driftsform") {
        return (
          <td key={`${uniqueKey}`} className={tdClassName}>
            <label className={labelClassName} htmlFor={`driftsform-${uniqueKey}`}>
                {column.header}
            </label>
            <TableOptionsEiendomDriftsform
              id={`driftsform-${uniqueKey}`}
              handleChange={handleChange}
              index={item}
              disabled={isUserEditingAdminColumn}
            />
          </td>
        );
      } else if (column.key === "belop" || column.key === "omsetning") {
        return (
          <td
            key={`${uniqueKey}`}
            className={tdClassName + " flex justify-end"}
          >
            <Input
              flex={!!column.textStyle}
              className={`${column.textStyle ?? "flex text-right pr-2"}`}
              name={column.key as string}
              label={column.header}
              id={`${String(column.key)} ${uniqueKey}`}
              labelopts={labelStyle}
              placeholder={column.header}
              value={item[column.key] as unknown as string}
              isNumberField={true}
              type="text"
              onChange={(e) => handleChange(e, item)}
              disabled={isUserEditingAdminColumn}
            />
            <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
              <span className="flex items-center px-2">NOK</span>
            </span>
          </td>
        );
      } else if (column.key === "alternativ") {
        return (
          <td
            key={`${uniqueKey}`}
            className={tdClassName}
          >
            <TableOptionsGaverBidrag
              handleChange={handleChange}
              index={item}
            />
          </td>
        );
      } else
        return (
          <td
            key={`${uniqueKey}`}
            className={tdClassName}
          >
            <Input
              //@ts-ignore
              key={`row-input2-${index}-${cIndex}-${column.header}`}
              className="text-center text-medium font-thin text-right w-full pr-4"
              id={`${String(column.key)}-${uniqueKey}`}
              label={column.header}
              isNumberField={column.isNumberField}
              labelopts={labelStyle}
              labelClassName="text-xl text-black flex text-right"
              type={column.inputType}
              placeholder={column.header}
              name={column.key as string}
              value={item[column.key] as unknown as string}
              onChange={(e) => handleChange(e, item)}
              disabled={isUserEditingAdminColumn}
            />
          </td>
        );
  } 

  const itemRow = (item: T, index: number, column: ColumnDefinitionType<T, K>, cIndex: number, keys: number[]) => {
    const isUserEditingAdminColumn = column.editAsAdminOnly === true && !isAdmin

    return (
        <tr
            className="block p-1"
            key={`row-${index}-${cIndex}`}
            id={`row-for-${keys[index]}-${cIndex}` as unknown as string}
        >
            {getColumnCell(item, index, column, cIndex, isUserEditingAdminColumn)}
        </tr>
    )
  }

  const verticalRows = items.map((item, index) => {
    const itemRows = columns.map((column, cIndex) => itemRow(item, index, column, cIndex, keys));

    const itemHeader = (
        <tr key={`header-${index}`}>

            <th className="w-1/16 pl-2 text-left text-xl font-thick">
                <div>
                <p className="">
                    {entityName} {index + 1}
                </p>
                </div>
            </th>
            {showRowActions && (
              <th>
              <button
                  type="button"
                  onClick={
                  //@ts-ignore
                  () => removeRow(item.id)
                  }
                  className="items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110 mx-auto"
              >
                  <svg className="w-10 h-10 " viewBox="0 0 24 24">
                  <path
                      fill="currentColor"
                      d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"
                  />
                  </svg>
                  <p>Fjern</p>
              </button>
              </th>
            )}
        </tr>
    )

    return (
        <div className="m-8">
            {itemHeader}
            {itemRows}
        </div>
    )
  });

  const leftItems = verticalRows.filter((x, i) => i % 2 === 0)
  const rightItems = verticalRows.filter((x, i) => i % 2 === 1)

  return <tbody className="w-800">
    <div className="w-1/2 float-left">
        {leftItems}
    </div>
    <div className="w-1/2 float-right">
        {rightItems}
    </div>
  </tbody>;
};

export default VerticalRows;